// custom.js

// 🛒 Drawer Cart Add Button Handler
document.addEventListener('DOMContentLoaded', function () {
  if (window.cartButtonHandlerInitialized) return;
  window.cartButtonHandlerInitialized = true;

  document.body.addEventListener('submit', function (e) {
    const form = e.target.closest('.cart-btn');
    if (!form) return;

    e.preventDefault();
    const formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then((response) => response.json())
      .then(() => fetch('/cart.js'))
      .then((res) => res.json())
      .then((cart) => {
        import('@theme/events').then(({ CartUpdateEvent }) => {
          const event = new CartUpdateEvent(cart, 'manual-trigger', {
            itemCount: cart.item_count,
            source: 'custom-add-button',
            sections: {},
          });
          document.dispatchEvent(event);

          const cartDrawer = document.querySelector('cart-drawer-component');
          if (cartDrawer && cartDrawer.hasAttribute('auto-open')) {
            cartDrawer.open();
          }
        });
      })
      .catch((error) => console.error('Error adding to cart:', error));
  });
});

// 💳 Buy Now Button Handler (Direct Checkout)
document.addEventListener("DOMContentLoaded", function() {
  if (window.buyNowHandlerInitialized) return;
  window.buyNowHandlerInitialized = true;

  document.body.addEventListener('submit', async function(e) {
    const form = e.target.closest('.buy-btn');
    if (!form) return;

    e.preventDefault();
    const formData = new FormData(form);

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      window.location.href = '/checkout';
    } catch (err) {
      console.error('Error adding to cart:', err);
    }
  });
});
